export default __webpack_public_path__ + "static/media/logo_vinhomes.64fa625d.png";